import MobileMenu from "./MobileMenu";

export default function ToggleMobileMenu({navRef,toggle,user,setToggle,onSignUpHandler,onSignInHandler,onSignOutHandler}) {
  return (
    <>
    {toggle && (
              <div
                className={`fixed left-0 right-0 bottom-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden ${
                  !user && window.innerWidth > 640 && window.innerWidth < 1024
                    ? "top-[93px]"
                    : "top-[75px]"
                }`}
                onClick={() => setToggle(false)}
              />
            )}
    <ul
    ref={navRef}
    className={`lg:hidden no-scrollbar w-[90%] max-w-[400px] overflow-y-auto left-[5%] md:w-[350px] md:left-auto flex-col gap-[12px] fixed md:right-[20px] z-50 ${
      toggle
        ? !user && window.innerWidth > 640 && window.innerWidth < 1024
          ? "top-[93px] max-h-[calc(100vh-93px)]"
          : "top-[75px] max-h-[calc(100vh-75px)]"
        : "top-[-1000%]"
    }`}
  >
    <MobileMenu
      setToggle={setToggle}
      signUp={onSignUpHandler}
      signIn={onSignInHandler}
      signOut={onSignOutHandler}
    />
  </ul>
  </>
  )}